<template>
  <footer class="footer">
    <!-- 底部导航 -->
    <div class="footer-nav">
      <div class="container">
        <div class="footer-content">
          <div class="footer-left">
            <img src="../assets/image/footer-logo.png" alt="logo" class="footer-logo">
            <div class="footer-info">
              <div class="footer-title" style="color:  rgba(255, 255, 255, 0.4);">河南省智睿研评成果评价技术中心</div>
              <div class="footer-hotline"><span style="color: rgba(255, 255, 255, 0.4);">服务热线：</span>{{ phone }}</div>
            </div>
          </div>
          <div class="footer-middle">
            <div class="footer-column">
              <div class="column-title">关于我们</div>
              <div class="column-item" @click="handleClick('about')">关于我们</div>
              <div class="column-item" @click="handleClick('contact')">联系我们</div>
            </div>
            <div class="footer-column">
              <div class="column-title">操作流程</div>
              <div class="column-item" @click="handleClick('consult')">使用咨询</div>
            </div>
            <div class="footer-column">
              <div class="column-title">服务条款</div>
              <div class="column-item" @click="handleClick('consult')">隐私声明</div>
              <div class="column-item" @click="handleClick('consult')">服务条款</div>
            </div>
            <div class="footer-column">
              <div class="column-title">帮助中心</div>
              <div class="column-item" @click="handleClick('consult')">常见问题</div>
              <div class="column-item" @click="handleClick('consult')">付款方式</div>
            </div>
          </div>
          <div class="footer-right">
            <img :src="httphosts+code" alt="二维码" class="footer-qrcode">
            <div class="qrcode-text">微信公众号</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <div class="footer-bottom">
      <div class="container">
        <div class="bottom-content">
          <div class="copyright">{{ IPC }}</div>
          <div class="certification">
            <img src="../assets/image/logos.png" alt="认证" class="cert-icon">
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { contactInfoConfig,init } from '@/api/index.js'
import { httphosts } from '@/utils/global'

export default {
  name: 'Footer',
  data() {
    return {
      httphosts: httphosts,
      phone: '',
      code: '',
      IPC: ''
    }
  },
  mounted() {
    this.getContactInfo()
    this.getInit()
  },
  methods: {
    getContactInfo() {
      contactInfoConfig().then(res => {
        if (res.code === 1) {
          this.phone = res.data.contact_info_hotline.value
          this.code = res.data.contact_info_official_account.value
        }
      })
    },
    // GETINIT
    getInit() {
      init().then(res => {
        if (res.code === 1) {
          this.IPC = res.data.record_number.value
        }
      })
    },
    handleClick(type) {
      if (type === 'about') {
        this.$router.push({ path: '/about' }).catch(() => { })
        this.currentNav = 'about'
      } else if (type === 'contact') {
        this.$router.push({ path: '/contact' }).catch(() => { })
      } else if (type === 'consult') {
        this.$router.replace({ 
          path: '/', 
          query: { 
            timestamp: new Date().getTime()
          } 
        }).catch(() => { })
      }
    },
  }
}
</script>

<style scoped>
.footer {
  background: #282828;
  margin-top: 60px;
}

.footer-nav {
  padding: 40px 0;
  /* border-bottom: 1px solid #555; */
  position: relative;
}

.footer-nav::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  /* background: linear-gradient(to right, transparent, #0066cc, transparent); */
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.footer-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 100px;
}

.footer-logo {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
}

.footer-info {
  text-align: center;
  color: #fff;
}

.footer-title {
  font-size: 14px;
  margin-bottom: 8px;
}

.footer-hotline {
  font-size: 14px;
}

.footer-middle {
  display: flex;
  gap: 60px;
  flex: 1;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.column-title {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 8px;
}

.column-item {
  font-size: 14px;
  color: #bbb;
  cursor: pointer;
  transition: color 0.3s;
}

.column-item:hover {
  color: #0066cc;
}

.footer-right {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-qrcode {
  width: 100px;
  height: 100px;
  margin-bottom: 8px;
}

.qrcode-text {
  font-size: 12px;
  color: #fff;
}

.footer-bottom {
  padding: 20px 0;
  background: #0C0C0C;
}

.bottom-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.copyright {
  color: #999;
  font-size: 12px;
  margin: 0;
}

.certification {
  display: flex;
  gap: 20px;
  align-items: center;
}

.cert-icon {
  width: 505px;
  height: 36px;
  object-fit: contain;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
  
  .footer-left {
    margin-right: 0;
  }
  
  .footer-middle {
    flex-wrap: wrap;
    justify-content: center;
    gap: 40px;
  }
  
  .footer-column {
    align-items: center;
  }
  
  .certification {
    flex-wrap: wrap;
    justify-content: center;
  }
}

/* RTL 支持 */
.rtl .footer-content {
  direction: rtl;
}

.rtl .footer-middle {
  flex-direction: row-reverse;
}

.rtl .certification {
  flex-direction: row-reverse;
}
</style>